<template>
  <!-- 展览详情 -->
  <div class="page-exbition-detail">
    <!-- <div class="g-line"></div> -->
    <div class="intro g-content-wrap g-pad-top g-detail-page">
      <h1 class="tc m-font-1">{{ detailData.title }}</h1>
      <p class="time tc m-font-2">{{ detailData.createTimeStr }}</p>

      <div v-html="detailData.content" class="g-detail-html trans">
      </div>

      <div class="g-file" @click="goFile" v-show="detailData.fileList && detailData.fileList[0]">附件: {{
        detailData.fileList &&
        detailData.fileList[0] &&
        detailData.fileList[0].attName }}
      </div>
    </div>
  </div>
</template>

<script>
import videoPlayer from '@cmp/video-player'
export default {
  components: { videoPlayer },
  data() {
    return {
      detailData: {
      },
      detailId: this.$route.query.id,
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/webapi/commondetail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    goFile() {
      let pdfUrl = this.detailData.fileList && this.detailData.fileList[0].attPath
      // window.open(pdfUrl, '_blank')
      let fileName = this.detailData.fileList[0].attName
      this.$download.download(pdfUrl, fileName)
    }
  },
  created() {
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-exbition-detail {
  h1 {
    // font-size: 28px;
    // font-weight: bold;
    color: #000;
  }

  .time {
    // font-size: 16px;
    color: #999493;
    margin-top: 20px;
    margin-bottom: 40px;
  }
}
</style>
